type JsonValue = string | number | boolean | null | JsonObject | JsonArray;
type JsonArray = JsonValue[];
interface JsonObject {
    [key: string]: JsonValue;
}

const deepMerge = <T extends JsonObject>(obj1: T, obj2: Partial<T>): T => {
    const output = { ...obj1 };

    for (const key in obj2) {
        if (Object.prototype.hasOwnProperty.call(obj2, key)) {
            const val1 = obj1[key];
            const val2 = obj2[key];

            if (typeof val2 === "object" && val2 !== null && !Array.isArray(val2) && typeof val1 === "object" && val1 !== null && !Array.isArray(val1)) {
                output[key] = deepMerge(val1 as JsonObject, val2 as JsonObject) as T[Extract<keyof T, string>];
            } else {
                output[key] = val2 as T[Extract<keyof T, string>];
            }
        }
    }

    return output;
};

const generateUniqueToken = (): string => {
    const timestamp: number = new Date().getTime();
    const randomString: string = Math.random().toString(36).substring(2, 8);

    return `${timestamp}-${randomString}`;
};

export { deepMerge, generateUniqueToken };
